import React, { FC, useCallback } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { forms } from '@factorin/container.macro';

import { RadioGroup, RadioGroupProps } from 'Modules/ui3';


export const RadioGroupField: FC<FieldRenderProps<any> & RadioGroupProps> = ({
    mutate, input: { onChange, ...inputProps }, meta, helper, ...props
}) => {
    const hasError = meta.error || !meta.valid;
    return (
        <RadioGroup
            {...props}
            {...inputProps}
            helper={hasError
                ? <forms.errorRenderer error={meta.error} />
                : helper
            }
            error={hasError}
            onChange={useCallback(
                event => {
                    onChange(event.target.value);
                    if (mutate)
                        mutate(event.target.value);
                },
                [mutate, onChange],
            )}
        />
    );
};
